import {getWallOrientation} from "../../../walls/wall";
import {Box3} from "three";

export class Boundary {
    constructor(sceneObject) {
        this.sceneObject = sceneObject;
        this.orientation = getWallOrientation(sceneObject);
        this.boundingBox = new Box3().setFromObject(sceneObject);

        this.boundingBox.min.setY(0);
        this.boundingBox.max.setY(0);

        this.originalBoundingBox = new Box3().copy(this.boundingBox);
    }
}
